<template>
  <div id="app">
    <sys></sys>
  </div>
</template>

<script>
import sys from './views/AboutView.vue'
export default {
  name: "App",
  components: {sys},
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleSysClick() {
      window.open("https://zs.bignbiot.com/#/login");
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}
</style>
